import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import {
    createSelectNextRecord,
    createSelectPreviousRecord,
    createToggleCheckOnSelectedRecordsAction,
    getIsRecordLoaded,
    getMultiselectMode,
    hasDetailForm,
    isRecordChecked,
    isRecordSelected,
} from "@multiweb/reactCore/datasource";
import { GetDataRowSiblingType } from "@multiweb/reactUtils";
import { IAppState } from "@multiweb/types/react";
import {
    createHandleRecordClickAction,
    createSetSelectedRecordsAction,
    createTrySelectRecordAction,
} from "../../actions";
import {
    getAllowMultiselectMode,
    getInteractive,
    getRowTemplate,
} from "../../selectors";
import { FrameSharedProps } from "../../types";
import { DataRowComponent, DataRowComponentProps } from "../DataRowComponent";

export type DataRowProps = {
    /** Metoda pro získání sousedního řádku. */
    getSibling: GetDataRowSiblingType;
    /**
     * Obsahuje pevný klíč pro renderer, kterým se má vyrenderovat template pro řádek.
     * Pokud není vyplněn, prohledá se kolekce registrovaných šablon.
    */
    templateRendererKey?: string;
} & FrameSharedProps;

type StateProps = Pick<
    DataRowComponentProps,
    | "templateRendererKey"
    | "isRecordLoaded"
    | "hasDetailForm"
    | "isSelected"
    | "isChecked"
    | "multiselectMode"
    | "allowMultiselect"
    | "interactive"
>;

const mapStateToProps: MapStateToProps<StateProps, DataRowProps, IAppState> = (
    state,
    { dataSourceKey, recordId, templateRendererKey },
) => ({
    templateRendererKey: templateRendererKey || getRowTemplate(state, dataSourceKey),
    isRecordLoaded: getIsRecordLoaded(state, { dataSourceKey, recordId }),
    isSelected: isRecordSelected(state, { dataSourceKey, recordId }),
    isChecked: isRecordChecked(state, { dataSourceKey, recordId }),
    hasDetailForm: hasDetailForm(state, dataSourceKey),
    allowMultiselect: getAllowMultiselectMode(state, dataSourceKey),
    multiselectMode: getMultiselectMode(state, dataSourceKey),
    interactive: getInteractive(state, dataSourceKey),
});

type DispatchProps = Pick<
    DataRowComponentProps,
    | "handleRecordClick"
    | "toggleSelectedRecordsCheck"
    | "selectRecords"
    | "selectNextRecord"
    | "selectPreviousRecord"
    | "trySelectRecord"
>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, DataRowProps> = (
    dispatch,
    { dataSourceKey, recordId },
) => ({
    handleRecordClick: () => dispatch(createHandleRecordClickAction(dataSourceKey, recordId)),
    toggleSelectedRecordsCheck: () => dispatch(createToggleCheckOnSelectedRecordsAction(dataSourceKey)),
    selectRecords: (selectedRows) => dispatch(createSetSelectedRecordsAction(dataSourceKey, selectedRows)),
    selectNextRecord: (clearOtherSelections) => dispatch(createSelectNextRecord(dataSourceKey, clearOtherSelections)),
    selectPreviousRecord: (clearOtherSelections) => dispatch(createSelectPreviousRecord(dataSourceKey, clearOtherSelections)),
    trySelectRecord: () => dispatch(createTrySelectRecordAction(dataSourceKey, recordId)),
});

export const DataRow = connect(mapStateToProps, mapDispatchToProps)(DataRowComponent);
